import { useProjectFetch } from '~/composables/use-api';

/**
 * API functions for managing member role assignments.
 *
 * Uses dedicated endpoints instead of generic CRUD operations:
 * - POST /{project}/members/{user_id}/roles - attach roles
 * - DELETE /{project}/members/{user_id}/roles - detach roles
 */

interface RoleIdPayload {
	id: string;
}

/**
 * Attach roles to a project member.
 *
 * @param memberId - The user ID of the member
 * @param roleIds - Array of role IDs to attach
 */
export async function connectMemberRoles(memberId: string, roleIds: string[]): Promise<void> {
	if (roleIds.length === 0) return;

	const fetch = useProjectFetch();
	const payload: RoleIdPayload[] = roleIds.map((id) => ({ id }));

	await fetch(`members/${memberId}/roles`, {
		method: 'POST',
		body: payload,
	});
}

/**
 * Detach roles from a project member.
 *
 * @param memberId - The user ID of the member
 * @param roleIds - Array of role IDs to detach
 */
export async function disconnectMemberRoles(memberId: string, roleIds: string[]): Promise<void> {
	if (roleIds.length === 0) return;

	const fetch = useProjectFetch();
	const payload: RoleIdPayload[] = roleIds.map((id) => ({ id }));

	await fetch(`members/${memberId}/roles`, {
		method: 'DELETE',
		body: payload,
	});
}
